import { TestId as _TestId } from './test-ids';
export type TestId = _TestId;
export const TEST_ID_ATTR = 'data-test-id';
export const TEST_ID_SELECTOR = `[${TEST_ID_ATTR}]`;

export {
  HeaderTestIds,
  CreateBoardTestIds,
  HomeTestIds,
  NavigationTestIds,
  NotificationTestIds,
  PowerUpTestIds,
  TeamTestIds,
  CreateFirstBoardIds,
  PopoverTestIds,
  BillingIds,
  PurchaseFormIds,
  MoonshotTestIds,
  CardBackTestIds,
  BoardHeaderTestIds,
  EnterpriseDashboardTestIds,
  SelectTestIds,
} from './test-ids';
